//获取采购单列表(买家)
export const GET_PURCHASE_ORDER_LIST = "GET_PURCHASE_ORDER_LIST";
//获取采购单详情(买家)
export const GET_PURCHASE_ORDER_DETAIL = "GET_PURCHASE_ORDER_DETAIL";
//设置采购单详情
export const SET_PURCHASE_ORDER_DETAIL = "SET_PURCHASE_ORDER_DETAIL";
//取消采购单
export const CANCEL_PURCHASE_ORDER = "CANCEL_PURCHASE_ORDER";
//设置选中的采购单tab类型
export const SET_TAB_STATUS = "SET_TAB_STATUS";

//获取采购单列表(卖家)
export const GET_SELLER_PURCHASE_ORDER_LIST = "GET_SELLER_PURCHASE_ORDER_LIST";
//获取采购单详情(卖家)
export const GET_SELLER_PURCHASE_ORDER_DETAIL = "GET_SELLER_PURCHASE_ORDER_DETAIL";
//采购单审核(卖家)
export const AUDIT_SELLER_PIRCHASE_ORDER = "AUDIT_SELLER_PIRCHASE_ORDER";
//获取要审核的采购单(卖家)
export const GET_SELLER_CHECK_PIRCHASE_ORDER = "GET_SELLER_CHECK_PIRCHASE_ORDER";




// WEBPACK FOOTER //
// ./src/store/purchase-order/type.js